import React from 'react';
import { string } from 'prop-types';
import { Helmet } from 'react-helmet';

MetaData.propTypes = {
	title: string
};

export default function MetaData({ title }) {
	const pageTitle = `mtribes ${title ? `| ${title}` : ''}`;
	return (
		<Helmet htmlAttributes={{ lang: 'en' }}>
			{/* Only inserting this placeholder during SSR. Code needs to be inserted with template literal,
			see https://github.com/nfl/react-helmet/issues/448#issuecomment-709354525 */}
			{typeof window === 'undefined' && <script>{`var GLOBAL={};`}</script>}
			<title>{pageTitle}</title>
		</Helmet>
	);
}
